import axios from 'axios';
import appInfo from "../app-info";
import { apiHelper } from "./api_helper";

export const authApi = {
  signInSSO: async (ticket_key, hash) => {
    try {
      const res = await axios.post(
        appInfo.api_url + '/account/login',
        { ticket_key, hash }
      );
      return res.data;
    } catch (error) {
      return {
        is_success: false
      }
    }
  },
  getUser: () => apiHelper.post('account/detail'),
  signOut: () => apiHelper.post('/logout')
}